<template>
  <div class="ViewMentora365NotifyTab">
    <div class="container-fluid">
      <div class="row margin-top-3Perc">
        <div class="col-md-6 col-lg-6">
          <div class="row vertical-align">
            <div class="col-md-4 col-lg-4 text-align-right Padding-right-0px">
              <b>Group</b>
            </div>
            <div class="col-md-8 col-lg-8">
              <div class="form-group">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 Padding-left-0px Padding-right-0px">
                  <select class="form-control" v-model="getSelectedGroupObj">
                    <option value=-1 disabled>Select</option>
                    <option v-for="grpObj in getGroupList" v-bind:key="grpObj.GroupId" v-bind:value="grpObj">{{ grpObj.GroupName }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <!-- Status -->
          <div class="row vertical-align margin-top-4Point5Perc">
            <div class="col-md-4 col-lg-4 text-align-right Padding-right-0px">
              <b>Status</b>
            </div>
            <div class="col-md-8 col-lg-8">
              <div class="form-group">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 Padding-left-0px Padding-right-0px">
                  <select class="form-control" v-model="getStatus">
                    <option value=-1 disabled>Select</option>
                    <option value=0>Queued</option>
                    <option value=1>Sent</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div> 
        <div class="col-md-6 col-lg-6">
          <!-- Group Course -->
          <div class="row vertical-align">
            <div class="col-md-2 col-lg-2 text-align-right Padding-right-0px">
              <b>Group Course</b>
            </div>
            <div class="col-md-8 col-lg-8">
              <div class="form-group">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 Padding-left-0px Padding-right-0px">
                  <select class="form-control" v-model="selectedCourseMomentObj">
                    <option value='-1' disabled>Select</option>
                    <option v-for="momentCourseObj in getCourseMomentListValue" v-bind:key="momentCourseObj.GroupCourseMasterId" v-bind:value="momentCourseObj">{{ momentCourseObj.GroupName }} :: {{momentCourseObj.CourseTitle}} {{momentCourseObj.CourseSubTitle !== null && momentCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + momentCourseObj.CourseSubTitle + ']': ''}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-2 col-lg-2"></div>
          </div>
          <!-- End of group course -->
          <!-- Cohort -->
          <div class="row vertical-align margin-top-3Point5Perc">
            <div class="col-md-2 col-lg-2 text-align-right Padding-right-0px">
              <b>Cohort</b>
            </div>
            <div class="col-md-8 col-lg-8">
              <div class="form-group">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 Padding-left-0px Padding-right-0px">
                  <select class="form-control" v-model="currSelectedCohortObj">
                    <option value='-1' disabled>Select</option>
                    <option v-for="cohortObj in getAssociatedCohorts" v-bind:key="cohortObj.CohortId" v-bind:value="cohortObj">{{ cohortObj.CohortName }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-2 col-lg-2"></div>
          </div>
        </div>  
      </div>
      <div class="row margin-top-4Perc">  
        <div class="col-md-2 col-md-offset-5 col-lg-2 col-lg-offset-5">
          <button class="btn btn-default col-md-offset-2 col-md-8 col-lg-offset-2 col-lg-8 button-orange black-font-color" @click="showNotifList($event)">View</button>
        </div>  
        <div class="col-md-5 col-lg-5">
        </div>
      </div>      
    </div>
    <hr width="94%" size="10px">
    <View-notify-list v-if="showList" :notifList="getNotifList" :selectedNotifStatus="selectedStatus" :selectedCourseMomentObj="selectedCourseMomentObj" @refreshNotificationList="refreshList"></View-notify-list>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
     <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div> 
    <loader></loader>
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="sendNotification"></confirmation-alert>
  </div>
</template>

<script>
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { groupService } from '@/server-util/group-service'
import { groupCourseService } from '@/server-util/group-course-service'
import { cohortService } from '@/server-util/cohort-service'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import Loader from '@/components/dashboard/Loader'
import { notificationService } from '@/server-util/notification-service'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import ViewNotifyList from '@/components/notification/m365/ViewNotifyList'
export default {
  created: function () {
    this.getGroups()
  },
  data: function () {
    return {
      showConfirmationBox: false,
      prefixString: 'Are you sure you want to delete ',
      postString: '',
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      groupObj: -1,
      selectedCourseMomentObj: -1,
      courseMomentList: [],
      associatedCohortList: [],
      selectedCohortObj: -1,
      selectedStatus: -1,
      scheduledNotifList: [],
      showList: false
    }
  },
  components: {
    'alert-box': AlertBox,
    'confirmation-alert': ConfirmationOverlay,
    'loader': Loader,
    'View-notify-list': ViewNotifyList
  },
  methods: {
    refreshList (value) {
      if (value) {
        this.getScheduledOrSentList()
      }
    },
    getAssociatedCohortList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedCourseMomentObj !== -1
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getCohortListUsingGroupCourse(
            storeObj.state.access_token,
            this.selectedCourseMomentObj.GroupCourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Cohort list response
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                var subTitleName = this.selectedCourseMomentObj.CourseSubTitle === null ? '' : ' [' + this.selectedCourseMomentObj.CourseSubTitle + ']'
                this.errorMsg = 'No cohort found in \'' + this.selectedCourseMomentObj.GroupName + ' :: ' + this.selectedCourseMomentObj.CourseTitle + subTitleName + '\'.'
                this.selectedCohortObj = -1
              }
              this.associatedCohortList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Select Group ID is NULL hence declined LISTING Associated Cohort(s) OPERATION'
        )
      }
    },
    getAllGroupCourses: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        // AK: If group courses are not available then only show spinner
        if (storeObj.state.groupCourseList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        groupCourseService
          .getGroupCourseList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupCourseList = responseObj.data
              if (this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              // AK: Hide Spinner after recieving Group Course list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined GROUP COURSE LISTING OPERATION'
        )
      }
    },
    getGroups: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== null ||
        storeObj.state.access_token !== ''
      ) {
        // AK: Check weather Grouplist is already present or not?
        if (storeObj.state.groupList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        groupService.listGroups(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupList = responseObj.data
              // AK: Hide Spinner after recieving group list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING GROUP LIST')
      }
    },
    sendNotification (value) {
      if (value) {
        this.showConfirmationBox = false
      }
    },
    showNotifList: function (event) {
      if (this.checkRequiredFiledsBeforeSubmit()) {
        this.getScheduledOrSentList()
      } else {
        console.log('Validation fail')
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete element overlay
      this.showConfirmationBox = value
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      // AK: If user recieved success msg on sent email then only reset values (DM-2343)
      if (this.isNotifSentSuccessfully) {
        this.isNotifSentSuccessfully = false
        this.resetAllFields()
      }
    },
    resetAllFields: function () {
      this.groupObj = -1
      this.selectedCourseMomentObj = -1
      this.selectedCohortObj = -1
      this.selectedStatus = -1
      this.courseMomentList = []
      this.associatedCohortList = []
    },
    checkRequiredFiledsBeforeSubmit: function () {
      if (this.getSelectedGroupObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group.'
        return false
      } else if (this.selectedCourseMomentObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group course.'
        return false
      } else if (this.selectedCohortObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a cohort.'
        return false
      } else if (this.selectedStatus === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a status.'
        return false
      }
      return true
    },
    getMomentCourseList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== null ||
        storeObj.state.access_token !== ''
      ) {
        _this.$store.state.isLoading = true
        groupCourseService.getAvailableM365(storeObj.state.access_token, _this.groupObj.GroupId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              _this.courseMomentList = responseObj.data
              if (_this.courseMomentList.length === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No courses were found in \'' + this.getSelectedGroupObj.GroupName + '\' group.'
              }
              _this.$store.state.isLoading = false
            } else {
              // AK: Hide Spinner
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING GROUP LIST')
      }
    },
    formatAndShowDate: function (date) {
      if (date !== undefined) {
        var dateToPass = date
        if (dateToPass.indexOf('Z') === -1) {
          dateToPass += 'Z'
        }
        return '(' + dmAdminUtils.covertUtcToEstWithoutTime(dateToPass) + ')'
      }
    },
    getScheduledOrSentList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== null ||
        storeObj.state.access_token !== ''
      ) {
        _this.$store.state.isLoading = true
        var objToPass = {
          GroupCourseMasterId: this.selectedCourseMomentObj.GroupCourseMasterId,
          CohortId: this.selectedCohortObj.CohortId,
          Status: this.selectedStatus
        }
        notificationService.getScheduleNotification(storeObj.state.access_token, objToPass).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              _this.scheduledNotifList = responseObj.data
              _this.$store.state.isLoading = false
              if (_this.scheduledNotifList.length === 0) {
                _this.showAlertDialog = true
                _this.errorMsg = 'No notification(s) found for selected filters.'
                _this.showList = false
              } else {
                _this.showList = true
              }
              console.log('getScheduledOrSentList >>> ' + JSON.stringify(this.scheduledNotifList))
            } else {
              // AK: Hide Spinner
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING GROUP LIST')
      }
    }
  },
  computed: {
    getStatus: {
      get: function () {
        this.showList = false
        return this.selectedStatus
      },
      set: function (newValue) {
        this.selectedStatus = newValue
      }
    },
    getNotifList: {
      get: function () {
        return this.scheduledNotifList
      }
    },
    getCourseMomentListValue: {
      get: function () {
        return this.courseMomentList
      }
    },
    getAssociatedCohorts: {
      get: function () {
        return this.associatedCohortList
      }
    },
    currSelectedCohortObj: {
      get: function () {
        return this.selectedCohortObj
      },
      set: function (newValue) {
        this.selectedCohortObj = newValue
      }
    },
    getSelectedGroupObj: {
      // Used to hold only group dropdown values
      get: function () {
        return this.groupObj
      },
      set: function (newValue) {
        this.groupObj = newValue
        this.selectedCohortObj = -1
        this.selectedStatus = -1
        this.selectedCourseMomentObj = -1
        this.courseMomentList = []
        this.showList = false
        this.associatedCohortList = []
        this.getMomentCourseList()
      }
    },
    getGroupList: {
      get: function () {
        return this.$store.state.groupList
      }
    }
  },
  watch: {
    selectedCourseMomentObj: function () {
      // AK: Reset Selected Cohort Obj to -1 again when Group course changed by user
      this.selectedCohortObj = -1
      this.associatedCohortList = []
      this.getAssociatedCohortList()
    }
  },
  name: 'ViewMentora365NotifyTab'
}
</script>

<style scoped>
.opacity {
  opacity: 0.75;
}
.ViewMentora365NotifyTab {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-green {
  border: 1px solid green;
}
.width-70Perc {
  width: 70%;
}
.width-88Perc {
  width: 88%;
}
.width-90Perc {
  width: 90%;
}
.width-96Perc {
  width: 96%;
}
.text-align-left {
  text-align: left !important;
}
.text-align-right {
  text-align: right !important;
}
.Padding-left-0px {
  padding-left: 0px !important;
}
.Padding-right-0px {
  padding-right: 0px !important;
}
.font-size-18px {
  font-size: 18px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.background-gray {
  background-color: #ddd;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.margin-bottom-1Perc {
  margin-bottom: 2% !important;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.margin-top-4Perc {
  margin-top: 4%;
}
.margin-top-4Point2Perc {
  margin-top: 4.2%;
}
.margin-top-4Point4Perc {
  margin-top: 4.4%;
}
.margin-top-4Point5Perc {
  margin-top: 4.5%;
}
.margin-top-4Point7Perc {
  margin-top: 4.7%;
}
.margin-top-6Perc {
  margin-top: 6%;
}
.margin-top-4Point8Perc {
  margin-top: 4.8%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.right-border-color {
  /*border-right: 1px solid #43495e;*/
}
.vertical-align {
  display: flex;
  align-items: center;
}
.width-1Perc {
  width: 1% !important;
}
.cursor-pointer {
  cursor: pointer;
}
.width-9-Perc {
  width: 9% !important;
}
@media (max-width: 1024px) {
  .width-9-Perc {
    width: 11.5% !important;
  }
}
.font-weight-bold {
  font-weight: bold;
}
.font-size-15px {
  font-size: 15px;
}
.margin-0-auto{
  margin: 0 auto !important;
}
.border-color-yellow{
  border:1px solid yellow;
}
.demo-margin-left-1Perc{
  margin-left:1% !important;
}
.border-grey{
  border:1px solid grey;
}
.padding-left-1Perc{
  padding-left:1%;
}
.padding-left-12Perc{
  padding-left:12%;
}
.padding-bottom-2Perc{
  padding-bottom:2% !important;
}
.padding-bottom-5Perc{
  padding-bottom:5% !important;
}
.margin-bottom-10Perc{
  margin-bottom: 10% !important;
}
.padding-15px{
  padding:15px;
}
.border-1px{
  border: 1px solid #ccc;
}
.cursor-pointer{
    cursor: pointer;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.margin-top-0Point5Perc{
  margin-top: 0.5%;
}
.margin-top-1Perc{
  margin-top: 1%;
}
.margin-top-10px{
  margin-top: 10px;
}
.padding-right-0Perc{
  padding-right:0%;
}
.vertical-align {
  display: flex !important;
  align-items: center !important;
}
.align-center{
  align: center !important;
}
.button-orange{
    background-color: #f39c12 !important;
    border: 1px solid #f39c12 !important;
}
.text-align-left{
  text-align: left !important;
}
.red-border{
  border: 1px solid red;
}
.vertical-align {
  display: flex !important; 
  align-items: center !important;
}
.font-size-14Px{
  font-size: 14px !important;
}
.margin-top-5px{
  margin-top: 5px;
}
.border-red{
  border: 1px solid red;
}
.button-orange {
  background-color: #f39c12!important;
  border: 1px solid #f39c12!important;
}
.margin-top-15px {
  margin-top:15px;
}
.current_time {
  margin-top: 10px;
  text-align: left;
}
.btnRefresh {
  margin-left: 5px;
}
.usersList {
  max-height: 480px;
  overflow-y: auto;
}
.margin-top-3Point5Perc {
  margin-top:3.5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
</style>



// WEBPACK FOOTER //
// src/components/notification/m365/ViewMentora365Notify.vue